import { useSWRConfig } from 'swr';
import { putFetcher } from '@/api/fetchers';
import { employeeDetailedMergeUpdateEmployee } from '@/schemas/converters/employeeSchemasConverter';
import { type UpdateEmployee } from '@/schemas/API/PUT/employee/request';
import { type EmployeeDetailed } from '@/schemas/API/GET/employee/response';
import { displayError } from '@/utils/error/errorHandler';

/**
 * Hook that returns function that optimistically updates employee.
 */
const useUpdateEmployee = () => {
  const { mutate } = useSWRConfig();

  const updateEmployee = async (
    employeeId: number,
    updateEmployee: UpdateEmployee
  ): Promise<EmployeeDetailed | undefined> => {
    try {
      const updateFn = async (): Promise<EmployeeDetailed> => {
        // TODO it's a hotfix. Change the whole schema.
        const newEmployeeDetail: EmployeeDetailed = await putFetcher(
          `/employees/${employeeId}`,
          {
            ...updateEmployee,
            active: 'true',
            access: { services: [1], role: 'ADMIN' },
          }
        );
        return newEmployeeDetail;
      };

      const updatedEmployee = await mutate(
        `/employees/${employeeId}`,
        updateFn,
        {
          optimisticData: a =>
            employeeDetailedMergeUpdateEmployee(a, updateEmployee),
          revalidate: false,
          rollbackOnError: true,
          populateCache: true,
        }
      );

      return updatedEmployee;
    } catch (err) {
      displayError(err);
    }
  };

  return {
    updateEmployee,
  };
};

export default useUpdateEmployee;
